var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.451,
    height: 20.451,
    viewBox: "0 0 20.451 20.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-400 -133.801)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7",
    transform: "translate(400.627 137.851)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 3.136,
    cy: 3.15,
    rx: 3.136,
    ry: 3.15,
    transform: "translate(7.05 3.465)",
    fill: "#2d62ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6269",
    "data-name": "Path 6269",
    d: "M20.061,90.777c-2.411-2.926-6.06-5.743-9.874-5.743S2.722,87.853.313,90.777a1.374,1.374,0,0,0,0,1.745,20.458,20.458,0,0,0,3.572,3.394c4.271,3.123,8.324,3.13,12.6,0a20.457,20.457,0,0,0,3.572-3.394A1.375,1.375,0,0,0,20.061,90.777ZM10.187,87.24A4.41,4.41,0,1,1,5.8,91.65,4.406,4.406,0,0,1,10.187,87.24Z",
    transform: "translate(0 -85.035)",
    fill: "#2d62ed"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.bcc5f42f5ed0de3741d5ec4234ad6f09.svg";
export { ForwardRef as ReactComponent };